import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Button, Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  calculatedViewMode,
  getFilterData,
  getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { REGION_REGISTRY_MODULE, VEHICLES_REGISTRY_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import { addGlobalPopUpWrapper } from '../../../InformationScreenWrapper/actions';
import {
  POPUP_LIST_NAME, REGISTRIES_VEHICLE_STATUS_LIST,
  VEHICLE_STATUS_LIST,
} from '../../../../configs';
import getDefaultSort from '../../../../utils/getDefaultSort';
import { vehicleRegistryColumns } from '../../../VehicleRegistry/components/settings';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../../components/fields/TextInput/TextInput';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import FilterModal from '../../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../../FilterTemplate/components/filter-settings';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';
import { loadVehiclesList } from '../../../RegionRegistry/actions';
import { getRegisterData } from '../../../RegionRegistry/reducer';
import { vehicleColumns } from '../../../RegionRegistry/components/vehiclesColumns';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';

export function VehicleBox(props) {
  const { onClose = () => {}, currentApplicant = {} } = props;
  const dispatch = useDispatch();
  const {
    vehiclesListMeta,
    loadingVehiclesList,
    vehiclesList,
  } = useSelector(getRegisterData);
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const filterName = 'applicant-vehicle-list';
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].vehiclesListMeta, opts);
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const requestData = {
      ...paginationOpts,
      filter: {
        ...filterData,
        ...viewModeData,
        applicant_id: currentApplicant?.id,
      },
      sort,
    };
    const p1 = dispatch(loadVehiclesList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData(filterName, {}) });

  const [sort, setSort] = useState(getDefaultSort(vehicleColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => { loadData(); }, [sort]);
  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  const handleOpenTab = item => {
    window.open(`/region-registry/passenger-taxi?registry_id=${item?.id}`, '_blank');
  };

  return (
    <div className="applicant-body flex-column">
      <TimerLoader loading={loadingVehiclesList} />
      <div className="applicant-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'applicant.card.menu.vehicle' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={{
              name: 'status',
              type: String,
              labelKey: 'status',
            }}
            usePortal
            options={REGISTRIES_VEHICLE_STATUS_LIST}
            placeholder="Статус"
            addPlaceholder
          />
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.PASSENGER_TAXI}
              />
            )
            : null}
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={vehiclesList}
            columns={vehicleColumns}
            onDoubleClickByRow={item => handleOpenTab(item)}
            additionalColumns={[]}
            changeSort={changeSort}
            sort={sort}
            name="vehicle-grid"
            settingsFormatter={moreFormatter}
            rowClassFormatter={rowClassFormatter}
          />
        </div>
        <Pagination meta={vehiclesListMeta} list={vehiclesList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
